export default "__VITE_ASSET__BwbaR3QB__"